// extracted by mini-css-extract-plugin
module.exports =  {"bottom-divider":"jct3zO","bottomDivider":"jct3zO","discountRow":"x9RzAl","discountIcon":"NK6DVC"};